<!-- Toolbar -->
<mat-toolbar style="background:WHITE;">
  <span style="padding: 10px; "><!--img  width="150" alt="Angular Logo" src="../../../assets/img/isComply.png" /-->
    <img  style="vertical-align: middle;"    alt="Logo" [src]="img" />
  </span>
  <span  class="example-spacer"></span>
  <app-nav-bar *ngIf="this.apiService.isLoggedIn()"></app-nav-bar>
</mat-toolbar>
